import { useState, useEffect } from "react";
import { Switch } from "V2.0/common/switch";

export default function FollowUpToggle({ isEnabled, onToggleFollowUp, disabled }) {
  const handleToggle = async () => {
    onToggleFollowUp(!isEnabled);
  };

  return (
    <Switch
      color="emerald"
      id={`checkbox-${isEnabled}`}
      checked={isEnabled}
      onClick={handleToggle}
      disabled={disabled}
    />
  );
}
